// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3QYrk","subheader":"ReorderModal_subheader__LKnR0","listWrap":"ReorderModal_listWrap__2mPBV"};